import React, { useReducer } from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import hodgeContainerStyling from "./hodgecontainer.module.scss"
import Form from "react-bootstrap/Form"
import Chart from "react-google-charts"
import { isMobile } from "react-device-detect"
import layoutStyles from "../../components/layout/layout.module.scss"

const hodgeStatTypes = [
  {
    value: "2020finalists",
    display: "2020 - Hodge Trophy Finalists",
    subHeadText: "Take a look at your 2020 Hodge Trophy Finalists",
  },
  {
    value: "2019finalists",
    display: "2019 - Hodge Trophy Finalists",
    subHeadText:
      "You Know You Want to See This -- Your 2019 Hodge Trophy Finalists",
  },
  {
    value: "2018finalists",
    display: "2018 - Hodge Trophy Finalists",
    subHeadText:
      "Yes -- We have the goods on your 2018 Hodge Trophy Finalists! Read 'em and enjoy! BTW --- both Seth & Zahid are back for the 2019-20 season. They're pretty good.",
  },
  {
    value: "2017finalists",
    display: "2017 - Hodge Trophy Finalists",
    subHeadText:
      "Remember when Kyle Snyder only focused on Takedowns in College, even beating Jason Nolf in Takedowns per 7 minutes wrestled? Yeah, that was pretty sweet. Oh yeah, And, J'Den was pretty good as well.",
  },
  {
    value: "2016finalists",
    display: "2016 - Hodge Trophy Finalists",
    subHeadText:
      "Ready for a Flashback - The last time someone not from Penn State won the Hodge Trophy? Here you go:",
  },
  {
    value: "recentwinners",
    display: "Recent Hodge Trophy Winners",
    subHeadText:
      "How do the winners compare in their winning seasons? See their strengths and areas of slightly less strength in the numbers! ",
  },
  {
    value: "spencerlee",
    display: "Spencer Lee's Career",
    subHeadText:
      "This is good stuff. Here we describe Spencer Lee's dominant career in numbers.",
  },
  {
    value: "bonickal",
    display: "Bo Nickal's Career",
    subHeadText:
      "Who wouldn't want to see some sweet stats describing Bo Nickal's Career",
  },
  {
    value: "jnolf",
    display: "Jason Nolf's Career",
    subHeadText:
      "On any other planet, Nolf probably would have won the Hodge Trophy. An untimely injury and some other studs prevented that on this planet. Be that as it may, Nolf's stats are definitely other-worldly. Check it out!",
  },
  {
    value: "zretherford",
    display: "Zain Retherford's Career",
    subHeadText:
      "Hi - I'm Zain. Your hopping on the Zain train now. Is Zain still in college? No? Good, he'd probably still be wrecking dudes otherwise.",
  },
]

const dataSetTypes = [
  { value: "Primary", display: "Primary" },
  { value: "Secondary", display: "Secondary" },
  { value: "Numbers", display: "Numbers" },
]

function getChartTitle(props) {
  // console.log("getting chart title:" + props)
  // console.log(" still getting chart title:" + JSON.stringify(hodgeStatTypes))
  let chartTitleItem = hodgeStatTypes.filter(e => e.value === props)
  // console.log(chartTitleItem)
  let chartTitleText = chartTitleItem[0].display
  return chartTitleText
}

function getChartData(passedWrestlerSetID, passedDataSetID) {
  let chartMilterer = []
  chartMilterer = chartAllDataSets.filter(
    elem =>
      elem.chartWrestlerSet === passedWrestlerSetID &&
      elem.chartDataSet === passedDataSetID
  )

  chartMilterer = chartMilterer[0].chartData

  return chartMilterer
}

function getChartHeight(props) {
  //  console.log(props)
  if (props < 750) {
    //    console.log("in the less than")
    return "405px"
  } else {
    //    console.log("in the greater than")
    return "565px"
  }
}

const defaultChartTitle = "2020 - Hodge Trophy Finalists"
const defaultChartData = [
  [
    "Stat Type",
    "Spencer Lee",
    "Kollin Moore",
    "Ryan Deakin",
    "Shane Griffith",
    "Noah Adams",
    "Pat Glory",
    "Gable Steveson",
    "Chas Tucker",
  ],
  ["HCR", 0.784, 0.566, 0.496, 0.504, 0.454, 0.54, 0.586, 0.391],
  ["WOR", 0.923, 0.785, 0.791, 0.776, 0.718, 0.798, 0.786, 0.68],
  ["Bonus%", 0.889, 0.741, 0.65, 0.607, 0.387, 0.708, 0.733, 0.097],
  ["B% v R", 0.857, 0.538, 0.333, 0.143, 0.273, 0.429, 0.5, 0],
  ["TPER", 0.824, 0.71, 0.692, 0.716, 0.65, 0.757, 0.722, 0.539],
  ["Fall %", 0.235, 0.148, 0.25, 0.333, 0.167, 0.167, 0.267, 0.067],
  ["TD %", 0.789, 0.793, 0.743, 0.69, 0.533, 0.813, 0.815, 0.532],
]

const chartAllDataSets = [
  {
    chartWrestlerSet: "2020finalists",
    chartDataSet: "Primary",
    chartData: [
      [
        "Stat Type",
        "Spencer Lee",
        "Kollin Moore",
        "Ryan Deakin",
        "Shane Griffith",
        "Noah Adams",
        "Pat Glory",
        "Gable Steveson",
        "Chas Tucker",
      ],
      ["HCR", 0.784, 0.566, 0.496, 0.504, 0.454, 0.54, 0.586, 0.391],
      ["WOR", 0.923, 0.785, 0.791, 0.776, 0.718, 0.798, 0.786, 0.68],
      ["Bonus%", 0.889, 0.741, 0.65, 0.607, 0.387, 0.708, 0.733, 0.097],
      ["B% v R", 0.857, 0.538, 0.333, 0.143, 0.273, 0.429, 0.5, 0],
      ["TPER", 0.824, 0.71, 0.692, 0.716, 0.65, 0.757, 0.722, 0.539],
      ["Fall %", 0.235, 0.148, 0.25, 0.333, 0.167, 0.167, 0.267, 0.067],
      ["TD %", 0.789, 0.793, 0.743, 0.69, 0.533, 0.813, 0.815, 0.532],
    ],
  },
  {
    chartWrestlerSet: "2019finalists",
    chartDataSet: "Primary",
    chartData: [
      ["Stat Type", "Bo Nickal", "Jason Nolf", "Yianni D", "Ashnault"],
      ["HCR", 0.827, 0.803, 0.688, 0.559],
      ["WOR", 0.885, 0.848, 0.783, 0.768],
      ["Bonus%", 0.9, 0.871, 0.607, 0.594],
      ["B% v R", 0.7, 0.75, 0.2, 0.25],
      ["B% v AA", 0.6, 0.625, 0.143, 0.25],
      ["TPER", 0.867, 0.849, 0.714, 0.703],
      ["Fall %", 0.6, 0.484, 0.25, 0.25],
      ["TD %", 0.921, 0.855, 0.761, 0.605],
    ],
  },
  {
    chartWrestlerSet: "recentwinners",
    chartDataSet: "Primary",
    chartData: [
      [
        "Stat Type",
        "Spencer Lee (2020)",
        "Bo Nickal (2019)",
        "Z. Retherford (2018)",
        "Z. Retherford (2017)",
        "A. Dieringer (2016)",
      ],
      ["HCR", 0.784, 0.806, 0.783, 0.8, 0.733],
      ["WOR", 0.923, 0.885, 0.886, 0.9, 0.839],
      ["Bonus%", 0.889, 0.9, 0.839, 0.893, 0.818],
      ["B% v R", 0.857, 0.7, 0.636, 0.833, 0.667],
      ["B% v AA", 0, 0.6, 0.2, 0.857, 0.333],
      ["TPER", 0.824, 0.867, 0.861, 0.907, 0.793],
      ["Fall %", 0.235, 0.6, 0.567, 0.63, 0.364],
      ["TD %", 0.789, 0.921, 0.825, 0.859, 0.836],
    ],
  },
  {
    chartWrestlerSet: "bonickal",
    chartDataSet: "Primary",
    chartData: [
      [
        "Stat Type",
        "Bo Nickal (2019)",
        "Bo Nickal (2018)",
        "Bo Nickal (2017)",
        "Bo Nickal (2016)",
      ],
      ["WOR", 0.885, 0.812, 0.823, 0.763],
      ["Bonus%", 0.9, 0.742, 0.778, 0.657],
      ["B% v R", 0.7, 0.333, 0.538, 0.429],
      ["B% v AA", 0.6, 0.25, 0.444, 0],
      ["TPER", 0.867, 0.801, 0.827, 0.705],
      ["Fall %", 0.6, 0.516, 0.63, 0.229],
      ["TD %", 0.921, 0.779, 0.796, 0.697],
    ],
  },
  {
    chartWrestlerSet: "zretherford",
    chartDataSet: "Primary",
    chartData: [
      [
        "Stat Type",
        "Z. Retherford (2018)",
        "Z. Retherford (2017)",
        "Z. Retherford (2016)",
      ],
      ["WOR", 0.886, 0.9, 0.867],
      ["Bonus%", 0.839, 0.893, 0.886],
      ["B% v R", 0.636, 0.833, 0.75],
      ["B% v AA", 0.2, 0.857, 0.667],
      ["TPER", 0.861, 0.907, 0.833],
      ["Fall %", 0.567, 0.63, 0.429],
      ["TD %", 0.825, 0.859, 0.89],
    ],
  },
  {
    chartWrestlerSet: "2018finalists",
    chartDataSet: "Primary",
    chartData: [
      ["Stat Type", "Z. Retherford", "Bo Nickal", "Seth Gross", "Z. Valencia"],
      ["HCR", 0.797, 0.739, 0.626, 0.617],
      ["WOR", 0.886, 0.812, 0.821, 0.812],
      ["Bonus%", 0.867, 0.742, 0.8, 0.781],
      ["B% v R", 0.636, 0.333, 0.545, 0.563],
      ["B% v AA", 0.2, 0.25, 0.25, 0.25],
      ["TPER", 0.861, 0.801, 0.789, 0.76],
      ["Fall %", 0.567, 0.516, 0.4, 0.281],
      ["TD %", 0.825, 0.779, 0.646, 0.81],
    ],
  },
  {
    chartWrestlerSet: "2017finalists",
    chartDataSet: "Primary",
    chartData: [
      ["Stat Type", "Zain Retherford", "JDen Cox", "Kyle Snyder", "Jason Nolf"],
      ["HCR", 0.818, 0.662, 0.687, 0.761],
      ["WOR", 0.9, 0.795, 0.788, 0.862],
      ["Bonus%", 0.926, 0.704, 0.765, 0.926],
      ["B% v R", 0.833, 0.364, 0.556, 0.857],
      ["B% v AA", 0.857, 0.167, 0.429, 0.667],
      ["TPER", 0.907, 0.728, 0.755, 0.877],
      ["Fall %", 0.63, 0.222, 0.235, 0.519],
      ["TD %", 0.859, 0.822, 0.878, 0.866],
    ],
  },
  {
    chartWrestlerSet: "2016finalists",
    chartDataSet: "Primary",
    chartData: [
      [
        "Stat Type",
        "Alex Dieringer",
        "Zain Retherford",
        "Kyle Snyder",
        "Nahshon Garrett",
      ],
      ["HCR", 0.743, 0.688, 0.48, 0.616],
      ["WOR", 0.839, 0.867, 0.786, 0.795],
      ["Bonus%", 0.818, 0.886, 0.727, 0.676],
      ["B% v R", 0.667, 0.75, 0.4, 0.455],
      ["B% v AA", 0.333, 0.667, 0.25, 0.5],
      ["TPER", 0.793, 0.833, 0.727, 0.757],
      ["Fall %", 0.364, 0.429, 0.091, 0.297],
      ["TD %", 0.836, 0.89, 0.878, 0.789],
    ],
  },
  {
    chartWrestlerSet: "jnolf",
    chartDataSet: "Primary",
    chartData: [
      [
        "Stat Type",
        "Jason Nolf (2019)",
        "Jason Nolf (2018)",
        "Jason Nolf (2017)",
        "Jason Nolf (2016)",
      ],
      ["WOR", 0.839, 0.867, 0.786, 0.795],
      ["Bonus%", 0.818, 0.886, 0.727, 0.676],
      ["B% v R", 0.667, 0.75, 0.4, 0.455],
      ["B% v AA", 0.333, 0.667, 0.25, 0.5],
      ["TPER", 0.793, 0.833, 0.727, 0.757],
      ["Fall %", 0.364, 0.429, 0.091, 0.297],
      ["TD %", 0.836, 0.89, 0.878, 0.789],
    ],
  },
  {
    chartWrestlerSet: "spencerlee",
    chartDataSet: "Primary",
    chartData: [
      [
        "Stat Type",
        "Spencer Lee (2020)",
        "Spencer Lee (2019)",
        "Spencer Lee (2018)",
      ],
      ["HCR", 0.784, 0.718, 0.606],
      ["WOR", 0.923, 0.773, 0.814],
      ["Bonus%", 0.889, 0.731, 0.75],
      ["B% v R", 0.857, 0.563, 0.625],
      ["B% v AA", 0, 0.143, 0.375],
      ["TPER", 0.824, 0.712, 0.764],
      ["Fall %", 0.235, 0.308, 0.375],
      ["TD %", 0.789, 0.61, 0.649],
    ],
  },
  {
    chartWrestlerSet: "2020finalists",
    chartDataSet: "Secondary",
    chartData: [
      [
        "Stat Type",
        "Spencer Lee",
        "Kollin Moore",
        "Ryan Deakin",
        "Shane Griffith",
        "Noah Adams",
        "Pat Glory",
        "Gable Steveson",
        "Chas Tucker",
      ],
      ["TPR", 1.169, 0.655, 0.733, 0.656, 0.497, 0.798, 0.612, 0.466],
      ["NF/F %", 2.529, 0.778, 0.7, 0.556, 0.6, 1.542, 0.667, 0.1],
      ["RT %", 1, 0.833, 0.867, 0.667, 0.174, 0.727, 0.6, 0.536],
      ["BPR", 0.826, 0.781, 0.777, 0.737, 0.812, 0.672, 0.794, 0.765],
      ["E1/R2 %", 1, 1, 1, 0.96, 0.905, 0.783, 1, 0.852],
      ["ML %", 0.529, 0.869, 0.895, 0.876, 0.867, 0.802, 0.786, 0.962],
      ["MPER", 0.888, 0.756, 0.858, 0.781, 0.744, 0.898, 0.79, 0.697],
      ["PDIR", 0.864, 0.764, 0.739, 0.766, 0.692, 0.788, 0.77, 0.636],
    ],
  },
  {
    chartWrestlerSet: "2019finalists",
    chartDataSet: "Secondary",
    chartData: [
      ["Stat Type", "Bo Nickal", "Jason Nolf", "Yianni D", "Ashnault"],
      ["TPR", 0.805, 0.671, 0.626, 0.707],
      ["NF/F %", 1.067, 1.097, 0.893, 1.219],
      ["RT %", 0.889, 0.667, 0.5, 0.8],
      ["BPR", 0.788, 0.783, 0.755, 0.75],
      ["E1/R2 %", 0.929, 0.963, 0.913, 0.895],
      ["ML %", 0.581, 0.712, 0.781, 0.812],
      ["MPER", 0.835, 0.776, 0.774, 0.804],
      ["PDIR", 0.892, 0.87, 0.769, 0.75],
    ],
  },
  {
    chartWrestlerSet: "recentwinners",
    chartDataSet: "Secondary",
    chartData: [
      [
        "Stat Type",
        "Spencer Lee (2020)",
        "Bo Nickal (2019)",
        "Z. Retherford (2018)",
        "Z. Retherford (2017)",
        "A. Dieringer (2016)",
      ],
      ["TPR", 1.169, 0.805, 0.928, 0.868, 0.832],
      ["NF/F %", 2.529, 1.067, 1.7, 1.778, 1.394],
      ["RT %", 1, 0.889, 1, 0.8, 0.857],
      ["BPR", 0.826, 0.788, 0.786, 0.788, 0.71],
      ["E1/R2 %", 1, 0.929, 0.941, 0.962, 0.857],
      ["ML %", 0.529, 0.581, 0.657, 0.688, 0.66],
      ["MPER", 0.888, 0.835, 0.838, 0.821, 0.862],
      ["PDIR", 0.864, 0.892, 0.888, 0.922, 0.833],
    ],
  },
  {
    chartWrestlerSet: "bonickal",
    chartDataSet: "Secondary",
    chartData: [
      [
        "Stat Type",
        "Bo Nickal (2019)",
        "Bo Nickal (2018)",
        "Bo Nickal (2017)",
        "Bo Nickal (2016)",
      ],
      ["TPR", 0.805, 0.681, 0.663, 0.676],
      ["NF/F %", 1.067, 0.613, 1.111, 0.943],
      ["RT %", 0.889, 0.714, 0.444, 0.762],
      ["BPR", 0.788, 0.791, 0.807, 0.732],
      ["E1/R2 %", 0.929, 1, 0.9, 0.907],
      ["ML %", 0.581, 0.588, 0.643, 0.781],
      ["MPER", 0.835, 0.804, 0.801, 0.777],
      ["PDIR", 0.892, 0.828, 0.873, 0.759],
    ],
  },
  {
    chartWrestlerSet: "zretherford",
    chartDataSet: "Secondary",
    chartData: [
      [
        "Stat Type",
        "Z. Retherford (2018)",
        "Z. Retherford (2017)",
        "Z. Retherford (2016)",
      ],
      ["TPR", 0.928, 0.868, 0.786],
      ["NF/F %", 1.7, 1.778, 0.886],
      ["RT %", 1, 0.8, 0.833],
      ["BPR", 0.786, 0.788, 0.79],
      ["E1/R2 %", 0.941, 0.962, 1],
      ["ML %", 0.657, 0.688, 0.726],
      ["MPER", 0.838, 0.821, 0.874],
      ["PDIR", 0.888, 0.922, 0.856],
    ],
  },
  {
    chartWrestlerSet: "2018finalists",
    chartDataSet: "Secondary",
    chartData: [
      ["Stat Type", "Z. Retherford", "Bo Nickal", "Seth Gross", "Z. Valencia"],
      ["TPR", 0.928, 0.681, 0.887, 0.714],
      ["NF/F %", 1.7, 0.613, 1.567, 1.125],
      ["RT %", 1, 0.714, 0.917, 0.882],
      ["BPR", 0.786, 0.791, 0.766, 0.767],
      ["E1/R2 %", 0.941, 1, 0.976, 0.914],
      ["ML %", 0.657, 0.588, 0.681, 0.779],
      ["MPER", 0.838, 0.804, 0.828, 0.786],
      ["PDIR", 0.888, 0.828, 0.839, 0.805],
    ],
  },
  {
    chartWrestlerSet: "2017finalists",
    chartDataSet: "Secondary",
    chartData: [
      ["Stat Type", "Zain Retherford", "JDen Cox", "Kyle Snyder", "Jason Nolf"],
      ["TPR", 0.868, 0.7, 0.535, 0.64],
      ["NF/F %", 1.778, 1.037, 0.529, 1],
      ["RT %", 0.8, 0.75, 0.375, 0.625],
      ["BPR", 0.788, 0.788, 0.746, 0.807],
      ["E1/R2 %", 0.962, 0.929, 0.6, 0.973],
      ["ML %", 0.688, 0.869, 0.831, 0.71],
      ["MPER", 0.821, 0.83, 0.725, 0.74],
      ["PDIR", 0.922, 0.769, 0.806, 0.893],
    ],
  },
  {
    chartWrestlerSet: "2016finalists",
    chartDataSet: "Secondary",
    chartData: [
      [
        "Stat Type",
        "Alex Dieringer",
        "Zain Retherford",
        "Kyle Snyder",
        "Nahshon Garrett",
      ],
      ["TPR", 0.832, 0.786, 0.571, 0.726],
      ["NF/F %", 1.394, 0.886, 0.273, 1.27],
      ["RT %", 0.857, 0.833, 0.6, 0.632],
      ["BPR", 0.71, 0.79, 0.807, 0.761],
      ["E1/R2 %", 0.857, 1, 1, 0.963],
      ["ML %", 0.66, 0.726, 0.879, 0.712],
      ["MPER", 0.862, 0.874, 0.693, 0.847],
      ["PDIR", 0.833, 0.856, 0.767, 0.792],
    ],
  },
  {
    chartWrestlerSet: "jnolf",
    chartDataSet: "Secondary",
    chartData: [
      [
        "Stat Type",
        "Jason Nolf (2019)",
        "Jason Nolf (2018)",
        "Jason Nolf (2017)",
        "Jason Nolf (2016)",
      ],
      ["TPR", 0.671, 0.824, 0.64, 0.729],
      ["NF/F %", 1.097, 1.269, 1, 0.971],
      ["RT %", 0.667, 1, 0.625, 0.909],
      ["BPR", 0.783, 0.771, 0.807, 0.789],
      ["E1/R2 %", 0.963, 0.952, 0.973, 1],
      ["ML %", 0.712, 0.598, 0.71, 0.779],
      ["MPER", 0.776, 0.708, 0.74, 0.788],
      ["PDIR", 0.87, 0.866, 0.893, 0.871],
    ],
  },
  {
    chartWrestlerSet: "spencerlee",
    chartDataSet: "Secondary",
    chartData: [
      [
        "Stat Type",
        "Spencer Lee (2020)",
        "Spencer Lee (2019)",
        "Spencer Lee (2018)",
      ],
      ["TPR", 1.169, 1.025, 0.963],
      ["NF/F %", 2.529, 1.846, 1.75],
      ["RT %", 1, 0.7, 0.286],
      ["BPR", 0.826, 0.59, 0.757],
      ["E1/R2 %", 1, 0.692, 0.762],
      ["ML %", 0.529, 0.66, 0.598],
      ["MPER", 0.888, 0.851, 0.86],
      ["PDIR", 0.864, 0.786, 0.83],
    ],
  },
  {
    chartWrestlerSet: "2020finalists",
    chartDataSet: "Numbers",
    chartData: [
      [
        "Stat Type",
        "Spencer Lee",
        "Kollin Moore",
        "Ryan Deakin",
        "Shane Griffith",
        "Noah Adams",
        "Pat Glory",
        "Gable Steveson",
        "Chas Tucker",
      ],
      ["Dom.", 5, 4.26, 4.15, 4.36, 3.97, 4.54, 4.33, 3.32],
      ["TD/ 7M", 3.34, 5.71, 2.9, 2.45, 1.54, 2.7, 5.6, 2.01],
      ["Falls", 4, 4, 5, 9, 5, 4, 4, 2],
      ["PDI", 16, 11.6, 10.5, 11.7, 8.4, 12.7, 11.9, 6],
      ["Pt/7M", 25.4, 16.1, 9.6, 8.5, 9.9, 14, 14.3, 7],
      ["FT Mt", 4, 18, 16, 18, 22, 11, 10, 28],
      ["W v R", 7, 13, 9, 7, 11, 7, 8, 9],
      ["B v R", 6, 7, 3, 1, 3, 3, 4, 0],
    ],
  },
  {
    chartWrestlerSet: "2019finalists",
    chartDataSet: "Numbers",
    chartData: [
      ["Stat Type", "Bo Nickal", "Jason Nolf", "Yianni D", "Ashnault"],
      ["Dom.", 5.2, 5.1, 4.29, 4.22],
      ["TD/ 7M", 6.02, 6.43, 3.79, 3],
      ["Falls", 18, 15, 7, 8],
      ["PDI", 17.3, 16.3, 11.9, 11],
      ["Pt/7M", 16.3, 17.7, 13.3, 12.1],
      ["FT Mt", 9, 11, 16, 20],
      ["W v R", 10, 12, 10, 12],
      ["B v R", 7, 9, 2, 3],
      ["B v AA", 3, 5, 1, 2],
    ],
  },
  {
    chartWrestlerSet: "recentwinners",
    chartDataSet: "Numbers",
    chartData: [
      [
        "Stat Type",
        "Spencer Lee (2020)",
        "Bo Nickal (2019)",
        "Z. Retherford (2018)",
        "Z. Retherford (2017)",
        "A. Dieringer (2016)",
      ],
      ["Dom.", 5, 5.2, 5.19, 5.46, 4.76],
      ["TD/ 7M", 3.34, 6.02, 4.06, 4.57, 4.23],
      ["Falls", 4, 18, 17, 17, 12],
      ["PDI", 16, 17.3, 17.1, 18.6, 14.6],
      ["Pt/7M", 25.4, 16.3, 15.9, 17.2, 16.3],
      ["FT Mt", 4, 9, 10, 5, 14],
      ["W v R", 7, 10, 11, 12, 12],
      ["B v R", 6, 7, 7, 10, 8],
      ["B v AA", 0, 3, 1, 6, 1],
    ],
  },
  {
    chartWrestlerSet: "bonickal",
    chartDataSet: "Numbers",
    chartData: [
      [
        "Stat Type",
        "Bo Nickal (2019)",
        "Bo Nickal (2018)",
        "Bo Nickal (2017)",
        "Bo Nickal (2016)",
      ],
      ["Dom.", 5.2, 5.17, 5.44, 4.76],
      ["TD/ 7M", 6.02, 4.06, 4.57, 4.23],
      ["Falls", 18, 17, 17, 12],
      ["PDI", 17.3, 17.1, 18.6, 14.6],
      ["Pt/7M", 16.3, 15.9, 17.2, 16.3],
      ["FT Mt", 9, 10, 5, 14],
      ["W v R", 10, 11, 12, 12],
      ["B v R", 7, 7, 10, 8],
      ["B v AA", 3, 1, 6, 1],
    ],
  },
  {
    chartWrestlerSet: "zretherford",
    chartDataSet: "Numbers",
    chartData: [
      [
        "Stat Type",
        "Z. Retherford (2018)",
        "Z. Retherford (2017)",
        "Z. Retherford (2016)",
      ],
      ["Dom.", 5.17, 5.44, 5],
      ["TD/ 7M", 4.06, 4.57, 4.12],
      ["Falls", 17, 17, 15],
      ["PDI", 17.1, 18.6, 15.7],
      ["Pt/7M", 15.9, 17.2, 13.8],
      ["FT Mt", 10, 5, 13],
      ["W v R", 11, 12, 12],
      ["B v R", 7, 10, 9],
      ["B v AA", 1, 6, 4],
    ],
  },
  {
    chartWrestlerSet: "2018finalists",
    chartDataSet: "Numbers",
    chartData: [
      ["Stat Type", "Z. Retherford", "Bo Nickal", "Seth Gross", "Z. Valencia"],
      ["Dom.", 5.17, 4.81, 4.73, 4.56],
      ["TD/ 7M", 4.06, 5.2, 3.13, 5.13],
      ["Falls", 17, 16, 12, 9],
      ["PDI", 17.1, 14.5, 14.9, 13.4],
      ["Pt/7M", 15.9, 12.7, 15.7, 16.1],
      ["FT Mt", 10, 14, 12, 17],
      ["W v R", 11, 12, 10, 16],
      ["B v R", 7, 4, 6, 9],
      ["B v AA", 1, 2, 1, 2],
    ],
  },
  {
    chartWrestlerSet: "2017finalists",
    chartDataSet: "Numbers",
    chartData: [
      ["Stat Type", "Zain Retherford", "JDen Cox", "Kyle Snyder", "Jason Nolf"],
      ["Dom.", 5.44, 4.37, 4.53, 5.26],
      ["TD/ 7M", 4.57, 3.75, 8.62, 8.07],
      ["Falls", 17, 6, 4, 14],
      ["PDI", 18.6, 11.8, 13.5, 17.3],
      ["Pt/7M", 17.2, 12.9, 19.5, 21.7],
      ["FT Mt", 5, 17, 8, 8],
      ["W v R", 12, 11, 9, 14],
      ["B v R", 10, 4, 5, 12],
      ["B v AA", 6, 1, 3, 4],
    ],
  },
  {
    chartWrestlerSet: "2016finalists",
    chartDataSet: "Numbers",
    chartData: [
      [
        "Stat Type",
        "Alex Dieringer",
        "Zain Retherford",
        "Kyle Snyder",
        "Nahshon Garrett",
      ],
      ["Dom.", 4.76, 5, 4.36, 4.54],
      ["TD/ 7M", 4.23, 4.12, 8.88, 3.98],
      ["Falls", 12, 15, 1, 11],
      ["PDI", 14.6, 15.7, 11.7, 12.8],
      ["Pt/7M", 16.3, 13.8, 20.1, 14.9],
      ["FT Mt", 14, 13, 5, 19],
      ["W v R", 12, 12, 5, 11],
      ["B v R", 8, 9, 2, 5],
      ["B v AA", 1, 4, 1, 3],
    ],
  },
  {
    chartWrestlerSet: "jnolf",
    chartDataSet: "Numbers",
    chartData: [
      [
        "Stat Type",
        "Jason Nolf (2019)",
        "Jason Nolf (2018)",
        "Jason Nolf (2017)",
        "Jason Nolf (2016)",
      ],
      ["Dom.", 5.1, 5.04, 5.26, 4.91],
      ["TD/ 7M", 6.43, 5.78, 8.07, 6.05],
      ["Falls", 15, 16, 14, 16],
      ["PDI", 16.3, 16.1, 17.3, 16.3],
      ["Pt/7M", 17.7, 17.5, 21.7, 18.3],
      ["FT Mt", 11, 7, 8, 12],
      ["W v R", 12, 8, 14, 14],
      ["B v R", 9, 4, 12, 13],
      ["B v AA", 5, 1, 4, 4],
    ],
  },
  {
    chartWrestlerSet: "spencerlee",
    chartDataSet: "Numbers",
    chartData: [
      [
        "Stat Type",
        "Spencer Lee (2020)",
        "Spencer Lee (2019)",
        "Spencer Lee (2018)",
      ],
      ["Dom.", 5, 4.27, 4.58],
      ["TD/ 7M", 3.34, 2.1, 2.58],
      ["Falls", 4, 8, 9],
      ["PDI", 16, 12.6, 14.5],
      ["Pt/7M", 25.4, 15, 15.1],
      ["FT Mt", 4, 10, 7],
      ["W v R", 7, 13, 14],
      ["B v R", 6, 9, 10],
      ["B v AA", 0, 1, 3],
    ],
  },
]

const fmtFourBars = [
  {
    type: "NumberFormat",
    column: 1,
    options: {
      // prefix: '$',
      negativeColor: "red",
      negativeParens: false,
      fractionDigits: 3,
    },
  },
  {
    type: "NumberFormat",
    column: 2,
    options: {
      // prefix: '$',
      negativeColor: "red",
      negativeParens: false,
      fractionDigits: 3,
    },
  },
  {
    type: "NumberFormat",
    column: 3,
    options: {
      // prefix: '$',
      negativeColor: "red",
      negativeParens: false,
      fractionDigits: 3,
    },
  },
  {
    type: "NumberFormat",
    column: 4,
    options: {
      // prefix: '$',
      negativeColor: "red",
      negativeParens: false,
      fractionDigits: 3,
    },
  },
  {
    type: "NumberFormat",
    column: 5,
    options: {
      // prefix: '$',
      negativeColor: "red",
      negativeParens: false,
      fractionDigits: 3,
    },
  },
  {
    type: "NumberFormat",
    column: 6,
    options: {
      // prefix: '$',
      negativeColor: "red",
      negativeParens: false,
      fractionDigits: 3,
    },
  },
]

// const fmtThreeBars = [
//   {
//     type: "NumberFormat",
//     column: 0,
//     options: {
//       // prefix: '$',
//       negativeColor: "red",
//       negativeParens: false,
//       fractionDigits: 3,
//     },
//   },
//   {
//     type: "NumberFormat",
//     column: 1,
//     options: {
//       // prefix: '$',
//       negativeColor: "red",
//       negativeParens: false,
//       fractionDigits: 3,
//     },
//   },
//   {
//     type: "NumberFormat",
//     column: 2,
//     options: {
//       // prefix: '$',
//       negativeColor: "red",
//       negativeParens: false,
//       fractionDigits: 3,
//     },
//   },
// ]

// const fmtTwoBars = [
//   {
//     type: "NumberFormat",
//     column: 0,
//     options: {
//       // prefix: '$',
//       negativeColor: "red",
//       negativeParens: false,
//       fractionDigits: 3,
//     },
//   },
//   {
//     type: "NumberFormat",
//     column: 1,
//     options: {
//       // prefix: '$',
//       negativeColor: "red",
//       negativeParens: false,
//       fractionDigits: 3,
//     },
//   },
// ]

const reducer = (state, action) => {
  switch (action.type) {
    case "CHANGE_WRESTLER_SET":
      return {
        ...state,
        wrestlerSet: action.item,
        // dataSet: state.dataSet,
        // barFormatSyntax: getBarFormatter(state.chartData[0].length),
        chartData: getChartData(action.item, state.dataSet),
        chartTitle: getChartTitle(action.item),
        subHeadText: hodgeStatTypes
          .filter(elem => elem.value === action.item)
          .map(sachLage => sachLage.subHeadText),
      }
    case "CHANGE_DATA_SET":
      return {
        ...state,
        dataSet: action.item,
        chartData: getChartData(state.wrestlerSet, action.item),
      }
    default:
      return state
  }
}

const initialState = {
  chartTitle: defaultChartTitle,
  wrestlerSet: "2020finalists",
  dataSet: "Primary", //secondary, traditional
  barFormatSyntax: fmtFourBars,
  subHeadText:
    "Who's Leading the race to be a 2020 Hodge Trophy Finalist or Winner?",
  chartHeight: isMobile ? getChartHeight(500) : getChartHeight(900),
  chartData: defaultChartData,
}

function HodgeContainerCharts() {
  const [state, dispatch] = useReducer(reducer, initialState)

  const changeWrestlerSet = item => {
    dispatch({ type: "CHANGE_WRESTLER_SET", item })
  }

  const changeDataSet = item => {
    dispatch({ type: "CHANGE_DATA_SET", item })
  }

  return (
    <div>
      <div className={hodgeContainerStyling.raisedBackground}>
        {/* <h3>WAPRS&copy; Stat Charts</h3> */}
        <>
          <Row>
            <Col xs={12} sm={10} lg={6} xl={6} md={6}>
              <Form>
                <div key="chartSelector" className="mb-3">
                  <Form.Group as={Row}>
                    <Form.Label column sm="3">
                      <h6 className={layoutStyles.heading}>WRESTLER SET:</h6>
                    </Form.Label>{" "}
                    <Col sm="8">
                      <Form.Control
                        id="wrestlerSet"
                        tabIndex="0"
                        as="select"
                        value={state.wrestlerSet}
                        onChange={event =>
                          changeWrestlerSet(event.target.value)
                        }
                      >
                        {hodgeStatTypes.map(statType => (
                          <option key={statType.value} value={statType.value}>
                            {statType.display}
                          </option>
                        ))}
                      </Form.Control>{" "}
                      {/* <span>{wrestlerSet}</span> */}
                    </Col>
                  </Form.Group>
                </div>
              </Form>
            </Col>
            <Col xs={12} sm={10} lg={6} xl={6} md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm="3">
                  <h6 className={layoutStyles.heading}>DATA SET:</h6>
                </Form.Label>{" "}
                <Col sm="8">
                  <Form.Control
                    id="dataSet"
                    tabIndex="0"
                    as="select"
                    value={state.dataSet}
                    onChange={event => changeDataSet(event.target.value)}
                  >
                    {dataSetTypes.map(dataSetType => (
                      <option key={dataSetType.value} value={dataSetType.value}>
                        {dataSetType.display}
                      </option>
                    ))}
                  </Form.Control>{" "}
                </Col>
              </Form.Group>
            </Col>
          </Row>
        </>{" "}
      </div>
      <>
        <br />
        <div
          id="waprs_Charts"
          className={hodgeContainerStyling.raisedBackground}
        >
          <h6 className={layoutStyles.heading}>
            {state.dataSet} DATA SET for {state.chartTitle}{" "}
          </h6>
          {/* {setChartComponent()} */}
          {/* <h6>{state.subHeadText}</h6> */}
          <br />
          <Row>
            <Col xs={12} sm={12} lg={10} xl={10} md={12}>
              <>
                <Chart
                  height={state.chartHeight}
                  chartType="Bar"
                  loader={<div>Get Ready for Your Hodge Chart</div>}
                  data={state.chartData}
                  formatters={state.barFormatSyntax}
                  options={{
                    // Material design options
                    colors: ["#3a577c", "#4a859e"],
                    legend: { position: "top" },
                    chartArea: { width: "100%" },
                    chart: {
                      title: state.chartTitle,
                      subtitle: "Footnotes have Stat Definitions",
                    },
                    animation: {
                      startup: true,
                      easing: "linear",
                      duration: 3500,
                    },
                    hAxis: {
                      title: "Rating",
                      minValue: 0.0,
                      maxValue: 1.0,
                    },
                  }}
                />
              </>
            </Col>
          </Row>
          <br />
        </div>
      </>{" "}
    </div>
  )
}

export default HodgeContainerCharts
